module.exports = __webpack_public_path__ + "static/media/BNP_Paribas.a29f3c16.png";